export default __webpack_public_path__ + "static/media/webimg.e1d14c6a.png";